<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';

export default {
  components: { FormWizard, TabContent },

  page: {
    title: "Form Wizard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  data() {
    return {
      title: "Form Wizard",
      items: [
        {
          text: "Forms",
          href: "/"
        },
        {
          text: "Form Wizard",
          active: true
        }
      ],

      formData:                 new FormData(),

      selectedIndustry:         "",

      url_logo:                 "",
      url_file:                 "",
      nm_customer:              "",
      id_state:                 "",
      nm_state:                 "",
      num_zipCode:              "",
      de_address:               "",
      nm_city:                  "",
      num_licenseNumber:        "",
      nm_customerContact:       "",
      de_contactEmail:          "",
      num_contactPhoneNumber:   "",
      num_contactLicenseNumber: "",

      selectedProcesses:        [],
      selectedProducts:         [],

      de_vaccumSealer:          "",
      de_vaccumBags:            "",
      de_thermometer:           "",
      de_EMD:                   "",

      sn_standardEquipment:     "1",

      sn_agreedTerms:           false,

      industries:               [],
      processes:                [],
      products:                 [],
      states: [
        "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia", "Hawaii",
        "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
        "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico",
        "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
        "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
      ],
    };
  },
  created() {
    document.body.classList.remove("auth-body-bg");
  },
  mounted(){
    this.getIndustries();
    console.log('si entra');
  },
  methods:{
    handleFile(){
      this.url_file = this.$refs.url_logo.files[0];
    },

    logState(evt){
      let id_state = 0;

      for (var i = 0; i < this.states.length; i++) {
        if( evt.target.value == this.states[i]){
          id_state = i+1;
          this.id_state = id_state;
        }
      }
    },

    getIndustries(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/industries.php',
        {
          params: {
            request: 'getIndustries',
          }
        }
      )
      .then(response => {
        console.log(response);
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.industries  = response.data
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    getProcessesByIndustryID(){
      let app = this;

      Swal.fire({
        title: 'Getting product process.',
        showConfirmButton:false,
      });


      axios
      .get(
        window.serverPath+'dist/mvw/controllers/processes.php',
        {
          params: {
            request: 'getProcessesByIndustryID',
            idIndustry: app.selectedIndustry
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.processes  = response.data

          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getProductsByProcessID(){
      let app = this;

      Swal.fire({
        title: 'Getting products of selected processes.',
        showConfirmButton:false,
      });


      axios
      .get(
        window.serverPath+'dist/mvw/controllers/products.php',
        {
          params: {
            request: 'getProductsByProcessID',
            idProcess: app.selectedProcesses
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.products  = response.data;
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    checkIndustry(){
      if(this.selectedIndustry == null || this.selectedIndustry == ""){
        //Swal.fire("Opps!", "Please, select the industry your business belongs", "error");
        return false;
      }else{
        return true;
      }
    },

    checkProcess(){
      if(this.selectedProcesses.length > 0){
        this.getProductsByProcessID();
        return true;
      }else{
        Swal.fire("Opps!", "Please, at least one Process you will work.", "error");
        return false;
      }
    },

    checkProducts(){
      if(this.selectedProducts.length > 0){
        return true;
      }else{
        Swal.fire("Opps!", "Please, at least one Product you will work.", "error");
        return false;
      }
    },

    checkEquipments(){
      if( this.sn_standardEquipment == 0 ){
        if(
          this.de_vaccumSealer    == "" ||
          this.de_vaccumBags      == "" ||
          this.de_thermometer     == "" ||
          this.de_EMD             == ""
        ){
          Swal.fire("Opps!", "Please, full fill your equipment information.", "error");
          return false;
        }else{
          return true;
        }
      }else{
        return true;
      }
    },

    checkCompanyInformation(){
      if(
        this.nm_customer                == ""  ||
        this.id_state                   == ""  ||
        this.nm_state                   == ""  ||
        this.num_zipCode                == ""  ||
        this.de_address                 == ""  ||
        this.nm_city                    == ""  ||
        this.num_licenseNumber          == ""  ||

        this.nm_customerContact         == ""  ||
        this.de_contactEmail            == ""  ||
        this.num_contactPhoneNumber     == ""  ||
        this.num_contactLicenseNumber   == ""
      ){
        Swal.fire("Opps!","Please fill all Company and Contact information sections. Thanks.", "error");
        return false
      }else{
        //Appending file to the formData object to be send all in a single request later.
        this.formData.append('url_file',  this.url_file);
        this.getProcessesByIndustryID();
        return true;
      } 
    },

    onComplete(){
      let data = {
        "selectedIndustry":         this.selectedIndustry,
        "selectedProcesses":        this.selectedProcesses,
        "selectedProducts":         this.selectedProducts,
        "nm_customer":              this.nm_customer,
        "id_state":                 this.id_state,
        "nm_state":                 this.nm_state,
        "num_zipCode":              this.num_zipCode,
        "de_address":               this.de_address,
        "nm_city":                  this.nm_city,
        "num_licenseNumber":        this.num_licenseNumber,
        "nm_customerContact":       this.nm_customerContact,
        "de_contactEmail":          this.de_contactEmail,
        "num_contactPhoneNumber":   this.num_contactPhoneNumber,
        "num_contactLicenseNumber": this.num_contactLicenseNumber,
        "de_vaccumSealer":          this.de_vaccumSealer,
        "de_vaccumBags":            this.de_vaccumBags,
        "de_thermometer":           this.de_thermometer,
        "de_EMD":                   this.de_EMD
      };

      let app = this;

      Swal.fire({
        title: "Saving customer.",
        showConfirmButton:false,
      });

      //Appending the request, file and data to the formData object to be send all in a single request.
      this.formData.append('request',   'getData');
      this.formData.append('url_file',  app.url_file);
      this.formData.append('data',      JSON.stringify(data) );

      //Axios post with multipart/form-data header, so that backend knows there is a file to be handled.
      axios.post(
        window.serverPath+'dist/mvw/placeholders.php',
        this.formData,
        {
          headers: {'Content-Type': 'multipart/form-data'}
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if( response.data.Error){
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br><i>'+response.data.Error+'.</i><br><br>Please try again.</b></p>','error');
          }else{
            window.open(window.serverPath+"dist/mvw/templates/My-HACCP-Plan.docx");
            Swal.close();
            app.$router.push({ name: 'congratulations' });
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    }
  }
};
</script>

<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <a href="/" class="text-dark">
        <i class="mdi mdi-home-variant h2"></i>
      </a>
    </div>
    <div class="my-5 pt-sm-5">
      <div class="container">
        <div class="row text">
          <div class="col-sm-12">
            <div class="text-center">
              
              <div class="">
                <div class="card">
                  <div class="card-body">
                    <a href="#" class="logo logo-dark">
                      <span class="logo-sm">
                        <!--<img src="@/assets/images/evalmatters-logo.png" alt width="80" />-->
                        <img src="@/assets/images/logo.png" height="15" alt="GoComply"/>
                      </span>
                      <span class="logo-lg">
                       <!--<img src="@/assets/images/evalmatters-logo.png" alt width="80" />-->
                       <img src="@/assets/images/logo.png" height="50" alt="GoComply"/>
                      </span>
                    </a>

                    <h4 class="mb-4">Onboarding</h4>

                    <form-wizard color="#556ee6" @on-complete="onComplete">
                      <tab-content icon="bx ri-building-fill" title="Industry" :before-change="checkIndustry">
                        <div class="row mt-3">
                          <div class="col-sm-12">
                            <h2>Tell us about your industry</h2>
                            <p>The first step is to select your industry, this is important to understand which processes you may work in your daily activities.</p>

                            <div class="row">
                              <div class="col-sm-12 text-center mt-3" v-if="industries.length == 0">
                                <h4 class="text-center">Loading Industries</h4> <b-spinner variant="dark" role="status"></b-spinner>
                              </div>
                              <div class="col-lg-4 col-sm-6" v-for="(industry, index) in industries" :key="index">
                                <div class="text-left">
                                  <label class="card-radio-label mb-3">
                                    <input
                                      type="radio"
                                      name="pay-method"
                                      id="pay-methodoption1"
                                      class="card-radio-input"
                                      v-model="selectedIndustry"
                                      :value="industry.id_industry"
                                    />

                                    <div class="card-radio">
                                      <i class="mdi mdi-factory font-size-24 align-middle mr-2"></i>
                                      <span>{{industry.nm_industry}}</span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- end col -->
                        </div>
                        <!-- end row -->
                      </tab-content>

                      <tab-content icon="ri-article-line" title="Information" :before-change="checkCompanyInformation">
                        <div class="row mt-3">
                          <div class="col-12">
                            <h2>Thanks!!! Please tell us about your company</h2>
                            <p>Your company information will not be shared with any third party as is considered confidential information.</p>

                            <div class="row mt-5">
                              <h2>Company Information</h2>
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="nm_customer">Customer name</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="nm_customer"
                                      id="nm_customer"
                                      v-model="nm_customer"
                                    >
                                  </div>

                                  <div class="form-group">
                                    <label for="company-logo">Customer logo </label>
                                    <input id="company-logo" class="form-control w-full" type="file" ref="url_logo" accept=".png, .jpg, .jpeg" @change="handleFile"/>

                                    <div v-if="url_logo != ''" class="form-group">
                                      <img v-if="url_logo != ''" :src="url_logo" class="avatar-md" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-6">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="id_state">State</label>
                                    <select
                                      class="form-control"
                                      name="id_state"
                                      id="id_state"
                                      v-model="nm_state"
                                      @change="logState"
                                    >
                                      <option value="">SELECT CUSTOMER STATE</option>
                                      <option v-for="(state, index) in states" :key="index" :value="state">{{state}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-sm-6">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="num_zipCode">Zip Code</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="num_zipCode"
                                      id="num_zipCode"
                                      v-model="num_zipCode"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="de_address">Address</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="de_address"
                                      id="de_address"
                                      v-model="de_address"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="nm_city">City</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="nm_city"
                                      id="nm_city"
                                      v-model="nm_city"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="num_licenseNumber">Business License Number</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="num_licenseNumber"
                                      id="num_licenseNumber"
                                      v-model="num_licenseNumber"
                                      value=""
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row mt-5">
                              <h2>Contact Information</h2>
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="nm_customerContact">Contact name</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="nm_customerContact"
                                      id="nm_customerContact"
                                      v-model="nm_customerContact"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="de_contactEmail">Contact Email</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="de_contactEmail"
                                      id="de_contactEmail"
                                      v-model="de_contactEmail"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="num_contactPhoneNumber">Contact Phone Number</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="num_contactPhoneNumber"
                                      id="num_contactPhoneNumber"
                                      v-model="num_contactPhoneNumber"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="num_contactLicenseNumber">Contact License Number</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="num_contactLicenseNumber"
                                      id="num_contactLicenseNumber"
                                      v-model="num_contactLicenseNumber"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                          <!-- end col -->
                        </div>
                        <!-- end row -->
                      </tab-content>

                      <tab-content icon="ri-settings-5-fill" title="Process" :before-change="checkProcess">
                        <div class="row mt-3">
                          <div class="col-12">
                            <h2>Now, what´s the process(es) you will do?</h2>
                            <p></p>

                            <div class="row">
                              <div class="col-lg-4 col-sm-6" v-for="(process, index) in processes" :key="index">
                                <div class="text-left">
                                  <label class="card-checkbox-label mb-3">
                                    <input
                                      type="checkbox"
                                      name="pay-method"
                                      id="pay-methodoption1"
                                      class="card-checkbox-input"
                                      v-model="selectedProcesses"
                                      :value="process.id_process"
                                    />

                                    <div class="card-checkbox">
                                      <i class="mdi mdi-shape-plus font-size-24 align-middle mr-2"></i>
                                      <span>{{process.nm_process}}</span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- end col -->
                        </div>
                        <!-- end row -->
                      </tab-content>

                      <tab-content icon="ri-gift-2-line" title="Products" :before-change="checkProducts">
                        <div class="row mt-3">
                          <div class="col-12">
                            <h2>Good!!! Now, select the products you want to work in your company.</h2>
                            <p></p>

                            <div class="row">
                              <div class="col-lg-4 col-sm-6" v-for="(product, index) in products" :key="index">
                                <div class="text-left">
                                  <label class="card-checkbox-label mb-3">
                                    <input
                                      type="checkbox"
                                      name="pay-method"
                                      id="pay-methodoption1"
                                      class="card-checkbox-input"
                                      v-model="selectedProducts"
                                      :value="product"
                                    />

                                    <div class="card-checkbox">
                                      <i class="mdi mdi-food-variant font-size-24 align-middle mr-2"></i>
                                      <span>{{product.nm_product}}</span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- end col -->
                        </div>
                        <!-- end row -->
                      </tab-content>

                      <tab-content icon="ri-scales-2-fill" title="Equipment" :before-change="checkEquipments">
                        <div class="row mt-3">
                          <div class="col-sm-12">
                            <h2>Great!!! Please provide us with some equipment information.</h2>
                            <p>
                              Select one of below options. If you do not know the make and model of your equipment, we'll use industry standard information.<br>
                              Remember, you can always edit your document later.
                            </p>
                          </div>
                        </div>
                        
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="row">
                              <div class="col-lg-6 col-sm-6">
                                <div class="text-left">
                                  <label class="card-radio-label mb-3">
                                    <input
                                      type="radio"
                                      name="pay-method"
                                      id="pay-methodoption1"
                                      class="card-radio-input"
                                      v-model="sn_standardEquipment"
                                      value="0"
                                    />

                                    <div class="card-radio">
                                      <i class="mdi mdi-blender font-size-24 align-middle mr-2"></i>
                                      <span>I know the Information</span>
                                    </div>
                                  </label>
                                </div>
                              </div>

                              <div class="col-lg-6 col-sm-6">
                                <div class="text-left">
                                  <label class="card-radio-label mb-3">
                                    <input
                                      type="radio"
                                      name="pay-method"
                                      id="pay-methodoption1"
                                      class="card-radio-input"
                                      v-model="sn_standardEquipment"
                                      value="1"
                                    />

                                    <div class="card-radio">
                                      <i class="mdi mdi-blender font-size-24 align-middle mr-2"></i>
                                      <span>Use standard information</span>
                                    </div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- end col -->
                        </div>

                        <div class="row mt-5" v-if="sn_standardEquipment==0">
                          <div class="col-sm-12">
                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="de_vaccumSealer">Vaccum Sealer</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="de_vaccumSealer"
                                      id="de_vaccumSealer"
                                      v-model="de_vaccumSealer"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="de_vaccumBags">Vaccum Bags</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="de_vaccumBags"
                                      id="de_vaccumBags"
                                      v-model="de_vaccumBags"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="de_thermometer">Thermometer</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="de_thermometer"
                                      id="de_thermometer"
                                      v-model="de_thermometer"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-sm-12">
                                <div class="text-left">
                                  <div class="form-group">
                                    <label for="de_EMD">Electronic Monitoring Device</label>
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="de_EMD"
                                      id="de_EMD"
                                      v-model="de_EMD"
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- end row -->
                      </tab-content>

                      <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                        <div class="row mt-3">
                          <div class="col-12">
                            <div class="text-center">
                              <h1 class="mt-0">
                                <i class="mdi mdi-check-all"></i>
                              </h1>
                              <h3 class="mt-0">Thank you!</h3>

                              <p class="w-75 mb-2 mx-auto">
                                By sharing with us this information, we can understand what you need and, it help us to develop the most accurate GoHACCP plan for your company. 
                                Remember, we do not share any business or personal data with third parties.
                              </p>

                              <div class="mb-3">
                                <div class="custom-control custom-checkbox">
                                  <b-form-checkbox v-model="sn_agreedTerms" switch class="mt-5" size="lg">
                                    <label>I agree with the Terms and Conditions</label>
                                  </b-form-checkbox>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- end col -->
                        </div>
                        <!-- end row -->
                      </tab-content>

                      <button type="button" class="btn btn-primary" slot="prev">Back</button>
                      <button type="button" class="btn btn-primary" slot="next">Next</button>
                      <button type="button" class="btn btn-success" slot="finish" :disabled="!sn_agreedTerms">Finish</button>
                    </form-wizard>
                  </div>
                  <!-- end card-body -->
                </div>
                <!-- end card -->
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="text/css">
.card-checkbox {
    background-color: #fff;
    border: 2px solid #f1f5f7;
    border-radius: 0.25rem;
    padding: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.card-checkbox:hover {
    cursor: pointer;
}
.card-checkbox-input:checked + .card-checkbox {
    border-color: #5664d2 !important;
}
.card-checkbox-label {
    display: block;
}
.card-checkbox-input {
    display: none;
}
</style>